
import { Component, Prop, Vue } from 'vue-property-decorator';
import NavbarItem from './NavbarItem.vue';

@Component<NavbarGroup>({
	components: {
		NavbarItem
	}
})
export default class NavbarGroup extends Vue {
	@Prop({ type: Boolean, required: true }) readonly mini!: boolean;
	@Prop({ type: Object, required: true }) readonly group!: NavbarItemSettings;

	private isOpen: boolean = true;

	/**
	 * Determines if the group should be displayed based on its condition.
	 *
	 * @return {boolean}
	 */
	private get showGroup(): boolean {
		return !this.group.hidden;
	}
}
